import React from "react";
import { Helmet } from "react-helmet-async";

export function TaskSeoNav() {
  const SeoRutaNav = { 
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type":"ListItem",
        position:1,
        name:"ROBÓTICA EMPRESA ECONOMÍA",
        item:"https://www.coronadosdelbien.com/robotica-empresa-economia"
      },{
        "@type":"ListItem",
        position:2,
        name:"CIENCIA",
        item:"https://www.coronadosdelbien.com/ciencia",
      },{
        "@type":"ListItem",
        position:3,
        name:"Super",
        item:"https://www.coronadosdelbien.com/Super",
      },{
        "@type":"ListItem",
        position:4,
        name:"TECNOLOGÍA",
        item:"https://www.coronadosdelbien.com/tecnologia",
      },{
        "@type":"ListItem",
        position:5,
        name:"MITO",
        item:"https://www.coronadosdelbien.com/mito",
      },{
        "@type":"ListItem",
        position:6,
        name:"NUEVOS DISPOSITIVOS",
        item:"https://www.coronadosdelbien.com/nuevos-dispositivos"
      },{
        "@type":"ListItem",
        position:7,
        name:"ESPACIO",
        item:"https://www.coronadosdelbien.com/espacio"
      },{
        "@type":"ListItem",
        position:8,
        name:"INTELIGENCIA ARTIFICIAL",
        item:"https://www.coronadosdelbien.com/inteligencia-artificial"
      },{
        "@type":"ListItem",
        position:9,
        name:"Coronados del bien | WebSite"
      }
    ],
  };
return (
    <Helmet>
        <link rel="apple-touch-icon" href="/favicon.ico" />
        <link rel="apple-touch-icon" sizes="/152x152" href="HD48.ico" />
        <link rel="apple-touch-icon" sizes="/180x180" href="HD96.ico" />
        <link rel="apple-touch-icon" sizes="/167x167" href="HD144.ico" />
        <link rel="alternate" href="https://coronadosdelbien.com/en" hreflang="en" type="application/atom+xml" title="Crowned of good" />
        <link rel="alternate" href="https://coronadosdelbien.com/ru" hreflang="ru" type="application/atom+xml" title="Увенчаны добром" />
        <link rel="alternate" href="https://coronadosdelbien.com/ga" hreflang="ga" type="application/atom+xml" title="coróinithe le maitheas" />
        <link rel="alternate" href="https://coronadosdelbien.com/fr" hreflang="fr" type="application/atom+xml" title="couronné de bien" />
        <link rel="alternate" href="https://coronadosdelbien.com/it" hreflang="it" type="application/atom+xml" title="coronato di bene" />
        <link rel="alternate" href="https://coronadosdelbien.com/de" hreflang="de" type="application/atom+xml" title="gekrönt mit gutem" />
        <link rel="alternate" href="https://coronadosdelbien.com/pl" hreflang="pl" type="application/atom+xml" title="ukoronowany dobrem" />
        <link rel="alternate" href="https://coronadosdelbien.com/pt" hreflang="pt" type="application/atom+xml" title="coroado com o bem" />
        <link rel="alternate" href="https://coronadosdelbien.com/zh" hreflang="zh-Hans" type="application/atom+xml" title="以善为冠冕" />
        <link rel="alternate" href="https://coronadosdelbien.com/nl" hreflang="nl" type="application/atom+xml" title="gekroond met goed" />
        <link rel="alternate" href="https://coronadosdelbien.com/sv" hreflang="sv" type="application/atom+xml" title="krönt med gott" />
        <link rel="alternate" href="https://coronadosdelbien.com/ar" hreflang="ar" type="application/atom+xml" title="متوج بالخير" />
        <link rel="alternate" href="https://coronadosdelbien.com/cy" hreflang="cy" type="application/atom+xml" title="wedi'i goroni â daioni" />
        <link rel="alternate" href="https://coronadosdelbien.com/sr" hreflang="sr" type="application/atom+xml" title="овенчан добрим" />
        <link rel="alternate" href="https://coronadosdelbien.com/hi" hreflang="hi" type="application/atom+xml" title="अच्छे से ताज पहनाया" />
        <script type="application/ld+json">{JSON.stringify(SeoRutaNav)}</script>
        <meta name="Google" content="index" />
        <meta name="Googlebot-Image" content="index" />
        <meta name="Googlebot-news" content="index" />
        <meta name="Yahoo" content="index" />
        <meta name="Bing" content="index" />
        <meta name="Netscape" content="index" />
        <meta name="Teoma" content="index" />
        <meta name="Bingbot" content="index" />
        <meta name="Adldxbot" context="index" />
        <meta name="seznambot" content="index" />
        <meta name="ia_archiver" content="index" />
        <meta name="MSMBot" content="index" />
        <meta name="Yeti" content="index" />
        <meta name="Yandex" content="index" />
        <meta name="Baiduspider" content="index" />
        <meta name="Naverbot" content="index" />
    </Helmet>
  );
}

export function TaskSeoNavSuper(){
  const SeoRutaNavSuper = { 
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type":"ListItem",
        position:12,
        name:"Luna es un satelite y controla misteriosamente la tierra",
        item:"https://www.coronadosdelbien.com/Super/reflejo-de-la-luna"
      },
      {
        "@type":"ListItem",
        position:11,
        name:"Sistemas Operativos",
        item:"https://www.coronadosdelbien.com/Super/sistemas-operativos"
      },{
        "@type":"ListItem",
        position:10,
        name:"Superconductores",
        item:"https://www.coronadosdelbien.com/Super/materiales-superconductores"
      },{
        "@type":"ListItem",
        position:9,
        name:"Empresa y economía",
        item:"https://www.coronadosdelbien.com/Super/paises-por-microcropocesadores"
      },{
        "@type":"ListItem",
        position:8,
        name:"Luna",
        item:"https://www.coronadosdelbien.com/Super/luna"
      },{
        "@type":"ListItem",
        position:7,
        name:"Trufa",
        item:"https://www.coronadosdelbien.com/Super/trufa"
      },{
        "@type":"ListItem",
        position:6,
        name:"Un nanotatuaje celular para salvar vidas",
        item:"https://www.coronadosdelbien.com/Super/celulas-tecnologicas"
      },{
        "@type":"ListItem",
        position:5,
        name:"Buscador navegador",
        item:"https://www.coronadosdelbien.com/Super/navegador"
      },{
        "@type":"ListItem",
        position:4,
        name:"Iphone",
        item:"https://www.coronadosdelbien.com/Super/iphone"
      },{
        "@type":"ListItem",
        position:3,
        name:"Las criptomonedas",
        item:"https://www.coronadosdelbien.com/Super/criptomonedas"
      },{
        "@type":"ListItem",
        position:2,
        name:"Oasis",
        item:"https://www.coronadosdelbien.com/Super/los-oasis-de-siempre"
      },{
        "@type":"ListItem",
        position:1,
        name:"Inteligencia artificial generativa",
        item:"https://www.coronadosdelbien.com/Super/inteligencia-artificial-y-generativa"
      }
    ],
  }

  return(
    <Helmet>
       <script type="application/ld+json">{JSON.stringify(SeoRutaNavSuper)}</script>
    </Helmet>
  )
}
 